import React from 'react';

import StubsWrapper from './StubsWrapper';
import LineStub from './LineStub';

function MaterialHeaderStub() {
  return (
    <StubsWrapper>
      <LineStub style={{ width: '50%', height: '20px' }} />

      <LineStub style={{ marginTop: '10px', height: '23px' }} />

      <LineStub />

      <LineStub style={{ height: '17px' }} />
    </StubsWrapper>
  );
}

export default MaterialHeaderStub;
